import React from "react";
import CLink from "../cLinks";

const Cta = ({ cta }) => {
    return (
        <div className="flex_cta"><CLink className="button" {...cta} /></div>
    )
}

export default Cta;